<template>
  <ButtonSnsSmall class="btn-sns--email" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-email-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--email {
  @include bg-settings(
    '../../../../../../images/buttons/email-with-background.svg',
    $gray-1,
    100%,
    100%
  );
}
</style>
